/**
 * Regras puras de falha de ação dentro de uma etapa do fluxo (BR-WF-OS-002).
 *
 * O motor conclui a etapa mesmo quando uma ação é recusada (a falha vai para a
 * fila de erros). Para a tela não mostrar "Concluída" sem aviso, a etapa com
 * ação falha é exibida como "Falhou na ação" com a mensagem do servidor.
 *
 * CHANGELOG:
 *   RELEASE: 2026-10-17 v1.0.0 - Versão inicial.
 */

/** Situações gravadas pelo motor que significam ação falha */
const STATUS_FALHA = new Set(['falhou', 'failed', 'erro', 'error']);

export interface AcaoExecutada {
  codigo?: string;
  nome?: string;
  status?: string | null;
  erro?: string | null;
}

/** Ações executadas da etapa que falharam */
export function acoesFalhas<T extends AcaoExecutada>(acoes?: T[] | null): T[] {
  return (acoes ?? []).filter((a) => STATUS_FALHA.has(String(a.status ?? '').toLowerCase()));
}

/** Rótulo da etapa considerando falha de ação */
export function rotuloEtapa(base: string, falhas: number): string {
  return falhas > 0 ? 'Falhou na ação' : base;
}

/** Texto do alerta do cabeçalho: quantidade de ações falhas e o motivo */
export function resumoFalhas(acoes: AcaoExecutada[], fallback?: string | null): string | null {
  if (!acoes.length) return fallback ?? null;
  const qtd = acoes.length === 1 ? '1 ação falhou' : `${acoes.length} ações falharam`;
  const motivos = acoes.map((a) => `${a.nome ?? a.codigo}: ${a.erro ?? 'sem detalhe'}`).join(' | ');
  return `${qtd}. ${motivos}`;
}
